// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__1waYr","colMaxWidth":"Table_colMaxWidth__2UsLD"};